export default "__VITE_ASSET__B_oKepDF__"